import type { ActorRefFrom, SnapshotFrom } from 'xstate';
import { licensesFormMachine } from './licenseForm.machine';
import { Context } from './utils/types';

type LicensesSnapshot = SnapshotFrom<typeof licensesFormMachine>;

// ── Account-level selector (for LicensesWrapper) ──────────────────
// Narrows from full account context to just the licensesRef.
// Cast to ActorRefFrom to provide type safety without importing the account machine.
export const selectLicensesRef = (state: { context: Record<string, unknown> }) =>
  state.context.licensesRef as ActorRefFrom<typeof licensesFormMachine>;

// ── Shared selectors (used by useLicensesService) ─────────────────
export const selectActiveTab = (state: LicensesSnapshot): Context['activeTab'] =>
  state.context.activeTab;
export const selectModal = (state: LicensesSnapshot): Context['modal'] => state.context.modal;
export const selectLoading = (state: LicensesSnapshot): Context['loading'] => state.context.loading;

// ── DEA-specific selectors (used by useDeaService) ────────────────
export const selectDeaLicenses = (state: LicensesSnapshot): Context['deaLicenses'] =>
  state.context.deaLicenses;
export const selectDeaLicenseForm = (state: LicensesSnapshot): Context['deaLicenseForm'] =>
  state.context.deaLicenseForm;

// ── CDS-specific selectors (used by useCdsService) ────────────────
export const selectCdsLicenses = (state: LicensesSnapshot): Context['cdsLicenses'] =>
  state.context.cdsLicenses;
export const selectCdsLicenseForm = (state: LicensesSnapshot): Context['cdsLicenseForm'] =>
  state.context.cdsLicenseForm;
